import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { TagInfoType } from '../../models/Tag'
import Link from 'next/link'

type TagPillRowType = TagInfoType & {
  small?: boolean
}
export function TagPill (props: TagPillRowType): React.ReactNode {
  return (
    <TagPillButton $small={!!props.small}><Link passHref={true} href={props.slug}>{props.title}</Link></TagPillButton>
  )
}

export const TagPillButton = styled.div<any>`
  font-family: "Good Sans Regular";
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  border-radius: 100px;
  border: 1px solid ${colors.white};
  &:hover {
    opacity: 0.4;
  }  
  a {
    text-decoration: none;
    color: ${colors.white};
  }
  ${(props: any): string => props.$small
    ? `padding: 5px 10px; font-size: 10px;`
    : `padding: 10px 15px; font-size: 12px;`
  };

  ${(props: any): any => config(props).media.md`
    font-size: ${(props: any): string => props.$small ? `12px` : `14px`};
  `}
`

type TagPillRowPropsType = {
  id: string,
  small?: boolean,
  tags: TagInfoType[]
}
export function TagPillRow (props: TagPillRowPropsType): React.ReactNode {
  return (
    <Container className='TagPillRow'>
        {props.tags.map((tag: TagInfoType, index: number): React.ReactNode => {
          return (
            <TagPill {...tag} key={`tag-pill-row-${props.id}-${index}`} small={!!props.small} />
          )
        })}
    </Container>
  )
}

const Container = styled.div<any>`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 6px;
  ${(props: any): any => config(props).media.md`
    grid-gap: 8px;
  `}
`
